import { createContext } from 'react';
import { diagnosticsInitState, DiagnosticsState } from '../lib/state';

export const DiagnosticsContext =
  createContext<DiagnosticsState>(diagnosticsInitState);
